import { writable } from "svelte/store";

const grabbing = new writable("")

export default grabbing;